export default __webpack_public_path__ + "static/media/OrderOnIcon.f1a2faca.svg";